import { render } from "./UploadSuccessCard.vue?vue&type=template&id=0de5a162&ts=true"
import script from "./UploadSuccessCard.vue?vue&type=script&lang=ts"
export * from "./UploadSuccessCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__